// import React, { useRef, useState } from "react";
// import { Upload, X } from "lucide-react";

// const FileUploader = ({
//   name,
//   multiple = false,
//   label = "Upload File",
//   onChange,
//   styles = "border-2 border-dashed border-gray-300 rounded-md p-4",
// }) => {
//   const [files, setFiles] = useState([]);
//   const [previews, setPreviews] = useState([]);
//   const inputRef = useRef(null);

//   const handleFileChange = (fileList) => {
//     const newFiles = Array.from(fileList);
//     const newPreviews = newFiles.map((file) => URL.createObjectURL(file));

//     setFiles((prevFiles) => {
//       const updatedFiles = multiple ? [...prevFiles, ...newFiles] : newFiles;
//       if (onChange) onChange(updatedFiles);
//       return updatedFiles;
//     });

//     setPreviews((prevPreviews) =>
//       multiple ? [...prevPreviews, ...newPreviews] : newPreviews
//     );
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
//       handleFileChange(e.dataTransfer.files);
//     }
//   };

//   const handleClick = () => {
//     if (inputRef.current) {
//       inputRef.current.click();
//     }
//   };

//   const handleRemove = (index) => {
//     const updatedFiles = files.filter((_, i) => i !== index);
//     const updatedPreviews = previews.filter((_, i) => i !== index);

//     setFiles(updatedFiles);
//     setPreviews(updatedPreviews);

//     if (onChange) {
//       onChange(multiple ? updatedFiles : updatedFiles[0] || null);
//     }
//   };

//   return (
//     <div>
//       <label className="block mb-2 text-sm font-medium text-gray-700">
//         {label}
//       </label>
//       <div
//         className={`${styles} flex flex-col items-center justify-center cursor-pointer`}
//         onClick={handleClick}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={handleDrop}
//       >
//         <input
//           ref={inputRef}
//           type="file"
//           multiple={multiple}
//           className="hidden"
//           onChange={(e) => {
//             if (e.target.files) {
//               handleFileChange(e.target.files);
//             }
//           }}
//         />
//         <Upload className="w-6 h-6 text-gray-500" />
//         <p className="mt-2 text-sm text-gray-500">
//           Drag & drop or click to upload
//         </p>
//       </div>
//       <div className="mt-4 grid grid-cols-3 gap-2">
//         {previews.map((src, index) => (
//           <div
//             key={index}
//             className="relative w-full h-24 border rounded-md overflow-hidden"
//           >
//             <img
//               src={src}
//               alt={`Preview ${index + 1}`}
//               className="object-cover w-full h-full"
//             />
//             <button
//               onClick={() => handleRemove(index)}
//               className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 focus:outline-none"
//             >
//               <X className="w-4 h-4" />
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default FileUploader;
import React, { useRef, useState, useEffect } from "react";
import { Upload, X } from "lucide-react";

const FileUploader = ({
  name,
  multiple = false,
  label = "Upload File",
  onChange,
  styles = "border-2 border-dashed border-gray-300 rounded-md p-4",
  existingFiles = [], // Prop for pre-populating files
  accept, // Prop for restricting file types
  error,
}) => {
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const inputRef = useRef(null);

  // Effect to handle pre-populated files
  useEffect(() => {
    if (existingFiles && existingFiles.length > 0) {
      setPreviews(existingFiles);
      // If you need to set files state as well, you can map existingFiles to a File object
      // This is just a placeholder since existingFiles might be URLs or paths
      setFiles(existingFiles.map((file) => ({ name: file, url: file })));
    }
  }, [existingFiles]);

  const handleFileChange = (fileList) => {
    const newFiles = Array.from(fileList);
    const newPreviews = newFiles.map((file) => URL.createObjectURL(file));

    setFiles((prevFiles) => {
      const updatedFiles = multiple ? [...prevFiles, ...newFiles] : newFiles;
      if (onChange) onChange(updatedFiles);
      return updatedFiles;
    });

    setPreviews((prevPreviews) =>
      multiple ? [...prevPreviews, ...newPreviews] : newPreviews
    );
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileChange(e.dataTransfer.files);
    }
  };

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleRemove = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    const updatedPreviews = previews.filter((_, i) => i !== index);

    setFiles(updatedFiles);
    setPreviews(updatedPreviews);

    if (onChange) {
      onChange(multiple ? updatedFiles : updatedFiles[0] || null);
    }
  };

  return (
    <div
    className={`border ${
      error ? "border-red-500" : "border-gray-300"
    } rounded-md p-4 text-center cursor-pointer hover:border-black ${
      error ? "hover:border-red-500" : ""
    }`}
    >
      <label className="block mb-2 text-sm font-medium text-gray-700">
        {label}
      </label>
      <div
        className={`${styles} flex flex-col items-center justify-center cursor-pointer`}
        onClick={handleClick}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <input
          ref={inputRef}
          type="file"
          multiple={multiple}
          className="hidden"
          accept={accept} // Restrict file types
          onChange={(e) => {
            if (e.target.files) {
              handleFileChange(e.target.files);
            }
          }}
        />
        <Upload className="w-6 h-6 text-gray-500" />
        <p className="mt-2 text-sm text-gray-500">
          Drag & drop or click to upload
        </p>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2">
        {previews.map((src, index) => (
          <div
            key={index}
            className="relative w-full h-24 border rounded-md overflow-hidden"
          >
            <img
              src={src}
              alt={`Preview ${index + 1}`}
              className="object-cover w-full h-full"
            />
            <button
              onClick={() => handleRemove(index)}
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 focus:outline-none"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileUploader;